import {
  KeyboardArrowDown,
  Search
} from "@material-ui/icons";
import React from "react";
import { Col, Form,Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getTemplatesAction } from "../../actions/EmailTemplatesActions";
import noRecord from "./../../assets/img/no-record.png";

class EmailTemplates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showArchieve: false,
      show: false,
      showLoader: true,
      templates:[],
      filteredTemplates:[],
      searchParam: '',
    };
  }
  columns = [
    {
      name: "Email Type",
      selector: "type",
      sortable: true,
      width: "300px"
    },
    {
      name: "Subject",
      selector: "subject",
      sortable: true,
      ignoreRowClick: true
    }
  ];

  componentWillMount() {
    this.props.getTemplatesAction().then(res => {
      this.setState({ showLoader: false,
                      templates: this.props.templates || [],
                      filteredTemplates: this.props.templates || []});
    });
  }
  /**
   * @desc Email search by type and subject
   * @param {*} param 
   */
  search(param) {
    param = param.trim()
    var templates = [];
    templates = this.state.filteredTemplates.filter((o) => {
      var found = false;
      Object.keys(o).forEach((v) => {
        if (v === 'type' || v === 'subject') {
          var item = o[v] + ''
          if (item.toLowerCase().includes(param.toLowerCase())) {
            found = true
          }
        } 
      })
      return found
    })
    this.setState({
      templates: templates,
      searchParam: param
    })
  }
  render() {
    let rows = [];
    if (this.state.templates !== undefined) {
      for (var i = 0, len = this.state.templates.length; i < len; i++) {
        let template = this.state.templates[i];

        let data = {
          id: template._id,
          type: (
            <Link
              to={"/emails/" + template._id}
              className="p-0 text-capitalize"
            >
              {template.type}
            </Link>
          ),
          subject: template.subject
        };
        rows.push(data);
      }
    }
    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col>
            <h4 className="title-med mt-0 pt-1">Email Templates</h4>
          </Col>
          <Col xs="4" align="right">
            <div className="icon-wrapper ml-2">
              <Form.Control
                type="text"
                className="form-control-head"
                placeholder="Search"
                value={this.state.searchParam}
                onChange={e => {
                  this.search(e.target.value);
                }}
              />
              <span className="form-control-icn">
                <Search />
              </span>
            </div>
          </Col>
        </Row>

        {this.state.templates === undefined && this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Email templates Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    templates: state.reducer.templates
  };
};

export default connect(mapStateToProps, { getTemplatesAction })(EmailTemplates);
